import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaColors, YodaSpacing } from 'yoda-ui/yodaTheme';

export const mayaLayoutStyle: SxProps<Theme> = {
  width: '100vw',
  marginBottom: -YodaSpacing.xLarge,
  flexGrow: 1,
};

export const mayaLayoutContentStyle: SxProps<Theme> = {
  position: 'relative',
  flex: 3,
  paddingTop: YodaSpacing.xLarge,
  paddingX: fromUnitsToRem(60),
  paddingBottom: '128px',
  backgroundColor: YodaColors.blue1,
  width: '100%',
  boxSizing: 'border-box',

  '@media (max-width: 1700px)': {
    paddingX: fromUnitsToRem(32),
  },

  '@media (max-width: 1400px)': {
    paddingX: fromUnitsToRem(20),
  },

  '@media (max-width: 1300px)': {
    paddingX: fromUnitsToRem(15),
  },
};
